import React from 'react';
import { AnalyticsKeys, TrackPageLoad } from '@atlassian/ptc-common';
import RecordTransition from '../components/RecordTransition';
import WorkedOnPage from '../components/WorkedOnPage/lazy';
const UserProfileWorkedOn = ({
  match
}) => {
  const {
    userId
  } = match.params;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RecordTransition, {
    name: AnalyticsKeys.PROFILE_WORKED_ON_PAGE_VIEW
  }), /*#__PURE__*/React.createElement(TrackPageLoad, {
    name: AnalyticsKeys.PROFILE_WORKED_ON_PAGE_VIEW
  }), /*#__PURE__*/React.createElement(WorkedOnPage, {
    userId: decodeURIComponent(userId)
  }));
};
export default UserProfileWorkedOn;